<span *ngIf="date$ | async as date">{{ date | date: dateFormats.DateAndTime }}</span>
